<table class="cp-table is-tight">
  <thead>
    <tr>
      <th *ngIf="showContentsInfo">
        {{ 'common.bukTicketListComponent.tableHeaders.title' | translate }}
      </th>
      <th>
        {{ 'common.bukTicketListComponent.tableHeaders.sendDate' | translate }}
      </th>
      <th>
        {{
          'common.bukTicketListComponent.tableHeaders.expiryDate' | translate
        }}
      </th>
      <th>
        {{ 'common.bukTicketListComponent.tableHeaders.period' | translate }}
      </th>
      <th>
        {{
          'common.bukTicketListComponent.tableHeaders.ticketCount' | translate
        }}
      </th>
      <th>
        {{
          'common.bukTicketListComponent.tableHeaders.usedTicketCount'
            | translate
        }}
      </th>
      <th>
        {{
          'common.bukTicketListComponent.tableHeaders.activationRate'
            | translate
        }}
      </th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td *ngIf="showContentsInfo">
        <div class="flex flex-v-center book">
          <div class="flex-item-fit cover flex flex-v-center">
            <img
              class="cover-image mat-elevation-z1"
              [src]="group.content_image_url"
            />
          </div>
          <div class="title">{{ group.content_title }}</div>
        </div>
      </td>
      <td>
        {{ group.sendDate | toDate | date: 'yyyy.MM.dd.' }}
      </td>
      <td>
        {{ group.expiryDate | toDate | date: 'yyyy.MM.dd.' }}
      </td>
      <td>
        {{ group.period | periodTranslate }}
      </td>
      <td>
        {{ group.total | number }}
      </td>
      <td>
        {{ group.used | number }}
      </td>
      <td>{{ (group.used / group.total) * 100 | number: '1.0-2' }}%</td>
      <td class="content-fit">
        <a mat-raised-button color="primary" href="{{ downloadURL }}" download>
          {{
            'common.bukTicketListComponent.actions.downloadGroup' | translate
          }}
        </a>
      </td>
    </tr>
  </tbody>
</table>
